// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-preview-page-tsx": () => import("./../../src/pages/preview-page.tsx" /* webpackChunkName: "component---src-pages-preview-page-tsx" */),
  "component---src-pages-preview-post-tsx": () => import("./../../src/pages/preview-post.tsx" /* webpackChunkName: "component---src-pages-preview-post-tsx" */),
  "component---src-templates-page-tsx": () => import("./../../src/templates/page.tsx" /* webpackChunkName: "component---src-templates-page-tsx" */),
  "component---src-templates-post-tsx": () => import("./../../src/templates/post.tsx" /* webpackChunkName: "component---src-templates-post-tsx" */)
}

